import { SUPPORTED_UTC_OFFSETS } from '../time/timezone';

export const CONTENT_INDEX_NAME = 'CONTENT' as const;
export const EVENT_INDEX_NAME = 'EVENTS_dateDay_asc' as const;
export const TEAM_INDEX_NAME = 'TEAMS_dateDay_asc' as const;

export const EVENTS_UTC_NAMES = SUPPORTED_UTC_OFFSETS.map((offset) => {
  return `EVENTS_UTC${offset >= 0 ? '+' : ''}${offset}_dateDay_asc` as const;
});
